module.exports = __webpack_public_path__ + "static/txn_card-696113fc637c108cbd3a621b4c752e82.webp";